<template>
    <side-bar :background-color="sidebarBackground" short-title="SchoolDock" title="SchoolDock" v-if="accessDetails">
        <template slot="links">
            <sidebar-item :link="{
                name: 'Dashboard', icon: 'fa fa-television text-primary', path: '/dashboard'
            }" />
            <sidebar-item :link="{ name: 'School Portal', icon: 'fa fa-building text-blue', path: '/admin/sms' }" />
            <sidebar-item
                :link="{ name: 'EduSchool', icon: 'fa fa-graduation-cap text-blue', path: '/admin/eduschool' }" />
            <sidebar-item :link="{ name: 'Employee', icon: 'fa fa-users text-blue', path: '/admin/staff-registration' }"
                v-if="accessDetails.isSuperAdmin == true" />
            <sidebar-item
                :link="{ name: 'Settings', icon: 'fa fa-cogs text-blue', path: '/admin/sms-subscriptions-setup' }"
                v-if="accessDetails.isSuperAdmin == true" />
            <div class="dropdown-divider"></div>
            <sidebar-item :link="{ name: 'Log Out', icon: 'fa fa-right-from-bracket text-blue', path: '/' }"
                @click="logout" />
        </template>
    </side-bar>
</template>
<script>
export default {
    data() {
        return {
            onloader: "none",
            accessDetails: null,
            sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
        };
    },
    methods: {
        logout() {
            this.$store.dispatch("auth/Logout").then(() => {
                this.$router.push("/login");
            });
        },
    },
    mounted() {
        this.accessDetails = this.$store.getters['auth/_user'];
    },
}
</script>
